import { connect } from 'react-redux';
import has from 'lodash/has';

import AvailableDataSetCardOverviewTab from './AvailableDataSetCardOverviewTab';
import {
  fetchDataSetUpdateTime,
  fetchResourceMetricsAggregate,
  fetchResourceMetricsPerDay,
} from '../../../actions';
import { isPublicDataset } from '../../../lib/ResourceUtils';

import { getMetricsForDataSet } from '../../../reducers/selectors';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;
  let {
    request,
    entities: { users, orgs },
    sharedDatasets,
    publicDatasets,
    dataSets: { sampleUpdateTimeById },
  } = state;
  let isPublic = false,
    sharedByOrg = null,
    sharedByUser = null,
    summaryData = null,
    sampleUpdateTime = null;
  if (data) {
    isPublic = isPublicDataset(data);
    if (isPublic === false) {
      sharedByUser = users[data.owner];
      sharedByOrg = orgs[data.org];
      summaryData = has(sharedDatasets, `summaryById[${data.id}]`)
        ? sharedDatasets.summaryById[data.id]
        : null;
    } else {
      summaryData = has(publicDatasets, `summaryById[${data.id}]`)
        ? publicDatasets.summaryById[data.id]
        : null;
    }

    sampleUpdateTime = has(sampleUpdateTimeById, data.id) ? sampleUpdateTimeById[data.id] : null;
  }

  return {
    isPublic,
    sharedByUser,
    sharedByOrg,
    summaryData,
    sampleUpdateTime,
    metrics: getMetricsForDataSet(state, ownProps),
    isLoading: {
      aggMetrics: request.GET_RESOURCE_METRICS_AGGREGATE_REQUEST || false,
      dayMetrics: request.GET_RESOURCE_METRICS_BY_DAYS_REQUEST || false,
    },
  };
};

export default connect(mapStateToProps, {
  fetchDataSetUpdateTime,
  fetchResourceMetricsAggregate,
  fetchResourceMetricsPerDay,
})(AvailableDataSetCardOverviewTab);
